<span class="ant-radio-button" [class.ant-radio-button-checked]="checked" [class.ant-radio-button-disabled]="nzDisabled">
  <input type="radio" #inputElement class="ant-radio-button-input" [disabled]="nzDisabled" [checked]="checked" [attr.name]="name">
  <span class="ant-radio-button-inner"></span>
</span>
<span><ng-content></ng-content></span>